import en from '../locales/en.json';
import ru from '../locales/ru.json';
import de from '../locales/de.json';
import fr from '../locales/fr.json';
import es from '../locales/es.json';
import ptBR from '../locales/pt-BR.json';
import ja from '../locales/ja.json';
import ko from '../locales/ko.json';

export const SITE_URL = 'https://armprogress.mcdevlabs.com';

// MCDevLabs (the studio that builds ArmProgress): EN at root, other locales path-prefixed.
export const STUDIO_URL = 'https://www.mcdevlabs.com';
export const studioUrl = (lang: string, path = '') => `${STUDIO_URL}${lang === 'en' ? '' : `/${lang}`}${path}`;

export const LOCALES = ['en', 'ru', 'de', 'fr', 'es', 'pt-BR', 'ja', 'ko'] as const;
export type Lang = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Lang = 'en';

export const localeNames: Record<Lang, string> = {
  en: 'English',
  ru: 'Русский',
  de: 'Deutsch',
  fr: 'Français',
  es: 'Español',
  'pt-BR': 'Português',
  ja: '日本語',
  ko: '한국어',
};

export const htmlLang: Record<Lang, string> = {
  en: 'en',
  ru: 'ru',
  de: 'de',
  fr: 'fr',
  es: 'es',
  'pt-BR': 'pt-BR',
  ja: 'ja',
  ko: 'ko',
};
export const ogLocale: Record<Lang, string> = {
  en: 'en_US',
  ru: 'ru_RU',
  de: 'de_DE',
  fr: 'fr_FR',
  es: 'es_ES',
  'pt-BR': 'pt_BR',
  ja: 'ja_JP',
  ko: 'ko_KR',
};

// Prefix a locale-agnostic path ("/" | "/blog" | "/blog/slug") with the locale.
// English stays unprefixed.
export function localePath(lang: Lang, path = '/'): string {
  const clean = path === '/' ? '' : path;
  const base = lang === DEFAULT_LOCALE ? '' : `/${lang}`;
  return `${base}${clean}` || '/';
}

export type Strings = typeof en;

export const strings: Record<Lang, Strings> = {
  en,
  ru: ru as Strings,
  de: de as Strings,
  fr: fr as Strings,
  es: es as Strings,
  'pt-BR': ptBR as Strings,
  ja: ja as Strings,
  ko: ko as Strings,
};

export const getStrings = (lang: Lang): Strings => strings[lang] ?? en;

// hreflang alternates for a locale-agnostic path.
export function altLinks(path = '/'): { hreflang: string; href: string }[] {
  const out = LOCALES.map((l) => ({
    hreflang: htmlLang[l],
    href: `${SITE_URL}${localePath(l, path)}`,
  }));
  out.push({ hreflang: 'x-default', href: `${SITE_URL}${localePath(DEFAULT_LOCALE, path)}` });
  return out;
}
